(function() {
    'use strict';
    
a3_cabin_reports.controller('FlightConfigCtrl',FlightConfigCtrl)

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name FlightConfigCtrl
    * @description 
    *   Set the ETA of the flight
    * @ngInject
    */
function FlightConfigCtrl($scope,$uibModalInstance,flight,FlightFactory){

		$scope.cancel = cancel;
		$scope.save = save;
		$scope.flightETA = new Date(flight.ETA?  flight.ETA : flight.ScheduledArrival);

        /**
         * Save the new ETA
         * @memberof FlightConfigCtrl
         */
		function save() {
			if ($scope.flightETA){
				var ETAdate = $scope.flightETA;
				var STDdate =new Date(flight.ScheduledDeparture);

                var ETAtimestamp = ETAdate.getTime();
				var STDtimestamp = STDdate.getTime();
                
				ETAdate.setUTCFullYear(STDdate.getUTCFullYear());
				ETAdate.setUTCMonth(STDdate.getUTCMonth());
				ETAdate.setUTCDate(STDdate.getUTCDate());

				if(ETAtimestamp<STDtimestamp){
					ETAdate.setUTCDate(STDdate.getUTCDate() + 1);
				}
                $scope.flightETA = ETAdate;
			}
				 
			flight.ETA = $scope.flightETA;
			FlightFactory.updateFlight(flight);
			$uibModalInstance.close(flight);
		}
			
        /**
         * Close the modal
         * @memberof FlightConfigCtrl
         */
		function cancel() {
			$uibModalInstance.dismiss();
		}
	}

})();